import firebase from "../firebase"
import displayListingGenerateHtml from "../display-listing/generate-html";
import createListing from "../create-listing/create-listing";
import signUpProfile from "../sign-up_profile/signUpProfile";

const CTAChainOnboardingScreen = document.getElementById('CTAChainOnboardingScreen')
const CTAChainOnboardingScreenlistingsCon = document.getElementById('CTAChainOnboardingScreenlistingsCon')
const CTAChainOnboardingScreenButtonExit = document.getElementById('CTAChainOnboardingScreenButtonExit')
const CTAChainOnboardingScreenButtonExplore = document.getElementById('CTAChainOnboardingScreenButtonExplore')
const CTAChainOnboardingScreenButtonUploadProduct = document.getElementById('CTAChainOnboardingScreenButtonUploadProduct')
const CTAChainOnboardingScreenButtonLogin = document.getElementById('CTAChainOnboardingScreenButtonLogin')


class CTAChain {

    constructor() {
        console.log('CTAChain LIVE');

        this._evenst()
    }

    _hideWindow() {
        CTAChainOnboardingScreen.style.display = 'none'
    }

    _evenst() {
        CTAChainOnboardingScreenButtonExit.addEventListener('click', () => {
            this._hideWindow()
        })
        CTAChainOnboardingScreenButtonExplore.addEventListener('click', () => {
            this._hideWindow()
        })
        CTAChainOnboardingScreenButtonUploadProduct.addEventListener('click', () => {
            createListing._init()
            this._hideWindow()

        })
        CTAChainOnboardingScreenButtonLogin.addEventListener('click', () => {
            signUpProfile._open()
            this._hideWindow()
        })
        CTAChainOnboardingScreen.addEventListener('click', (e) => {
            const isListing = e.target.closest('.snap-slot')
            if (isListing) {
                this._hideWindow()
            }

        })

    }

    _hasUrlParameters(url = window.location.href) {
        const parsedUrl = new URL(url, window.location.origin);
        return !parsedUrl.searchParams.keys().next().done;
    }

    _onbordingWindowOpen() {

        const setWindow = async () => {
            const { listings, lastVisibleDoc } =
                await firebase._getMostRecentListingsWithOutFilterGlobal(
                    null,
                    7
                );
            console.log(listings);
            this._fillListings(listings, true)
        }

        if (this._hasUrlParameters()) {
            console.log("Startup URL has parameters");
        } else {
            console.log("Startup URL has no parameters");
            CTAChainOnboardingScreen.style.display = 'flex'
            setWindow()
        }
    }


    async _fillListings(listings, reset) {
        if (reset) {
            CTAChainOnboardingScreenlistingsCon.innerHTML = "";
        }
        for (const listing of listings) {
            // let html = displayListingGenerateHtml._listingVerticalNV(listing);
            let html = await displayListingGenerateHtml._listingVerticalMini(listing, null, null, null, null, false);

            CTAChainOnboardingScreenlistingsCon.insertAdjacentHTML(
                "beforeend",
                html
            );
        }
        // function setupResponsiveSnap(container) {
        //     if (container.dataset.snapReady) return;
        //     container.dataset.snapReady = "true";

        //     // Measure all children before changing their layout.
        //     const items = [...container.children].map(child => ({
        //         child,
        //         width: child.offsetWidth,
        //         height: child.offsetHeight,
        //     }));

        //     if (items.some(item => !item.width || !item.height)) {
        //         delete container.dataset.snapReady;
        //         return; // Initialize when the children are visible.
        //     }

        //     items.forEach(item => {
        //         const { child, width, height } = item;
        //         const slot = document.createElement("div");
        //         slot.className = "snap-slot";

        //         child.classList.remove("is-snapped");
        //         child.style.width = `${width}px`;
        //         child.style.height = `${height}px`;
        //         child.style.flexShrink = "0";

        //         child.before(slot);
        //         slot.append(child);
        //         item.slot = slot;
        //     });

        //     let frame;

        //     function updateActive() {
        //         const rect = container.getBoundingClientRect();
        //         const center =
        //             rect.left + container.clientLeft + container.clientWidth / 2;

        //         let closest;
        //         let shortest = Infinity;

        //         items.forEach(({ slot }) => {
        //             const bounds = slot.getBoundingClientRect();
        //             const distance = Math.abs(bounds.left + bounds.width / 2 - center);

        //             if (distance < shortest) {
        //                 shortest = distance;
        //                 closest = slot;
        //             }
        //         });

        //         items.forEach(({ slot }) => {
        //             slot.classList.toggle("is-snapped", slot === closest);
        //         });
        //     }

        //     function resize() {
        //         const screenWidth = document.documentElement.clientWidth;
        //         const normalWidth = screenWidth / 3;
        //         const activeWidth = screenWidth / 2.5;

        //         items.forEach(({ slot, width, height }) => {
        //             // Reserve enough room for the enlarged version.
        //             slot.style.width = `${activeWidth}px`;
        //             slot.style.height = `${height * (activeWidth / width)}px`;
        //             slot.style.setProperty("--scale", normalWidth / width);
        //             slot.style.setProperty("--active-scale", activeWidth / width);
        //         });

        //         // Allow the first and last children to snap to the center.
        //         const endSpace = Math.max(
        //             0,
        //             (container.clientWidth - activeWidth) / 2
        //         );

        //         container.style.paddingInline = `${endSpace}px`;
        //         updateActive();
        //     }

        //     container.addEventListener("scroll", () => {
        //         cancelAnimationFrame(frame);
        //         frame = requestAnimationFrame(updateActive);
        //     }, { passive: true });

        //     const observer = new ResizeObserver(resize);
        //     observer.observe(container);
        //     window.addEventListener("resize", resize);

        //     resize();
        // }

        // document
        //     .querySelectorAll(".nvOnboardingCon10")
        //     .forEach(setupResponsiveSnap);


        function setupResponsiveSnap(container) {
            if (container.dataset.snapReady) return;

            // Measure the children before wrapping them.
            const items = [...container.children].map(child => ({
                child,
                width: child.offsetWidth,
                height: child.offsetHeight,
            }));

            if (
                !items.length ||
                items.some(item => !item.width || !item.height)
            ) {
                return; // Run again once the children are visible.
            }

            container.dataset.snapReady = "true";

            items.forEach(item => {
                const { child, width, height } = item;
                const slot = document.createElement("div");

                slot.className = "snap-slot";

                child.classList.remove("is-snapped");
                child.style.width = `${width}px`;
                child.style.height = `${height}px`;
                child.style.flexShrink = "0";

                child.before(slot);
                slot.append(child);

                item.slot = slot;
            });

            let frame;

            function updateActive() {
                const rect = container.getBoundingClientRect();
                const center =
                    rect.left + container.clientLeft + container.clientWidth / 2;

                let closest = null;
                let shortest = Infinity;

                items.forEach(({ slot }) => {
                    const bounds = slot.getBoundingClientRect();
                    const distance = Math.abs(
                        bounds.left + bounds.width / 2 - center
                    );

                    if (distance < shortest) {
                        shortest = distance;
                        closest = slot;
                    }
                });

                items.forEach(({ slot }) => {
                    slot.classList.toggle("is-snapped", slot === closest);
                });
            }

            function resize() {
                const screenWidth = document.documentElement.clientWidth;
                const normalWidth = screenWidth / 3;
                const activeWidth = screenWidth / 2.5;

                items.forEach(({ slot, width, height }) => {
                    // Reserve space so the enlarged children don't overlap.
                    slot.style.width = `${activeWidth}px`;
                    slot.style.minWidth = `${activeWidth}px`;
                    slot.style.flex = `0 0 ${activeWidth}px`;
                    slot.style.height = `${height * (activeWidth / width)}px`;

                    slot.style.setProperty("--scale", normalWidth / width);
                    slot.style.setProperty("--active-scale", activeWidth / width);
                });

                // Let the first and last children reach the center.
                const endSpace = Math.max(
                    0,
                    (container.clientWidth - activeWidth) / 2
                );

                container.style.paddingInline = `${endSpace}px`;

                updateActive();
            }

            container.addEventListener(
                "scroll",
                () => {
                    cancelAnimationFrame(frame);
                    frame = requestAnimationFrame(updateActive);
                },
                { passive: true }
            );

            const observer = new ResizeObserver(resize);
            observer.observe(container);
            window.addEventListener("resize", resize);

            // Set dimensions before positioning the scroll.
            resize();

            // Start with the middle child centered.
            requestAnimationFrame(() => {
                const middleIndex = Math.floor(items.length / 2);
                const middleSlot = items[middleIndex].slot;

                const containerRect = container.getBoundingClientRect();
                const slotRect = middleSlot.getBoundingClientRect();

                const containerCenter =
                    containerRect.left +
                    container.clientLeft +
                    container.clientWidth / 2;

                const slotCenter = slotRect.left + slotRect.width / 2;

                container.scrollTo({
                    left: container.scrollLeft + slotCenter - containerCenter,
                    behavior: "instant",
                });

                updateActive();
            });
        }

        // Run after the children have been added and are visible.
        document
            .querySelectorAll(".nvOnboardingCon10")
            .forEach(setupResponsiveSnap);

    }

}


export default new CTAChain();